<template>
	<div>
	<v-container v-html="pageText" class="md-container">
		ssssssww
	</v-container>
	</div>
</template>

<script>
import mdTexts from "../../MarkdownTexts.js";
import MarkdownService from "../../services/mdService.js";

export default {
	name: "TextPage",
	
	data: function() {
		return {
			pageText: String,
			route: String,
		}
	},
	
	methods: {
		async getPageText() {
			var md = mdTexts
			var converter = new MarkdownService();
			
			var path = this.$route.path;
			this.route = path;
			var text;
			switch (path) {
				case "/impressum":
					text = md.impressum;
					break;
				
				
				case "/career":
					text = md.career;
					break;
				
				
				case "/angebote":
					text = md.angebote;
					break;
				
				
				case "/unternehmen":
					text = md.unternehmen;
					break;
					
				case "/datenschutz":
					text = md.privacy
					break;
					
				case "/arbeiten-bei-manitz-it":
					text = md.workText;
					break;
				
				case "/jobs":
					text = md.job;
					break;
				
			}
			console.log(text);
			this.pageText = converter.convertMarkdown(text);
		}
	},
	
	created() {
		this.getPageText();
	},
	
	watch: {
		$route() {
			this.getPageText();
		}
	}
}

</script>

<style scoped>

	.button-col {
		display: flex;
		flex-direction: column;
		justify-content: center;
	}

	.md-container >>> h1 {
		color: #999999;
		font-weight: normal;
		margin-bottom: 1em;
		font-size: 34px;
		position: relative;
	}

	.md-container >>> h1:after {
		content: "";
		color: transparent;
		width: 80px;
		border-bottom: 3px solid #ff922e;
		position: absolute;
		bottom: 0;
		left: 0;
	}

	.md-container >>> h2 {
		color: #ca6302;
		font-size: 30px;
		font-weight: normal;
		padding-top: 0.3em;
		padding-bottom: 0.3em;
	}

	.md-container >>> ul {
		list-style: none;
	}

	.md-container >>> li::before {
		content:"\2192";
		float: left;
		margin-right: 10px;
	}

</style>